import { AfterViewInit, Component, ElementRef, Input, ViewChild, Output, EventEmitter } from '@angular/core'
import * as PDFObject from 'pdfobject'
import { Router } from '@angular/router'

@Component({
    selector: 'mg-pdfobject',
    templateUrl: './pdfobject.component.html',
    styleUrls: ['./pdfobject.component.scss'],
})
export class PdfobjectComponent implements AfterViewInit {
    @Input()
    src: string

    @Input()
    proceedButtonText: string

    @Input()
    downloadButtonText: string = ''

    @Input()
    viewButtonText: string = ''

    @Output()
    proceedButtonClick = new EventEmitter()

    constructor() {}

    supportsPDFs: boolean = PDFObject.supportsPDFs

    @ViewChild('pdf')
    private pdfElementReference: ElementRef

    ngAfterViewInit() {
        if (this.supportsPDFs) {
            PDFObject.embed(this.src, this.pdfElementReference.nativeElement)
        }
    }

    handleButtonClick() {
        this.proceedButtonClick.emit()
    }
}
